import { createFetchedData, createQueryKey, LoadingState } from '@vista-digital/utilities';
import { browsingDomainStore } from '../../store';
export const getShowtimeIdsForQueryOnBusinessDate = (query, businessDate) => {
    const queryKey = createQueryKey(query);
    const showtimeIdsForQuery = browsingDomainStore.data.showtimeIdsForQueryByBusinessDate[queryKey];
    const showtimeIdsForQueryOnDate = showtimeIdsForQuery && showtimeIdsForQuery[businessDate];
    return showtimeIdsForQueryOnDate || createFetchedData(LoadingState.NotLoaded);
};
//# sourceMappingURL=get-showtime-ids-for-query-on-business-date.js.map